// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import store from './store'
import router from './router'

import BootstrapVue from 'bootstrap-vue'
Vue.use(BootstrapVue);

// import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'

import { library } from '@fortawesome/fontawesome-svg-core'
import { faPlaneDeparture, faPlaneArrival, faUser, faSuitcaseRolling, faTrashAlt, faCheckCircle, faClock, faTrash, faTachometerAlt, faUserCircle, faCar, faTimesCircle, faEdit, faCheck, faTimes, faPrint, faAngleRight, faDownload } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'

import Toasted from 'vue-toasted';

Vue.use(Toasted)

import VueCtkDateTimePicker from 'vue-ctk-date-time-picker';
import 'vue-ctk-date-time-picker/dist/vue-ctk-date-time-picker.css';

Vue.component('VueCtkDateTimePicker', VueCtkDateTimePicker);

library.add(faPlaneDeparture, faPlaneArrival, faUser, faSuitcaseRolling, faTrashAlt, faCheckCircle, faClock, faTrash, faTachometerAlt, faUserCircle, faCar, faTimesCircle, faEdit, faCheck, faTimes, faPrint, faAngleRight, faDownload)

Vue.component('font-awesome-icon', FontAwesomeIcon)

Vue.config.productionTip = false

import moment from 'moment-timezone'

Vue.prototype.moment = moment

import parsePhoneNumber from 'libphonenumber-js'
Vue.prototype.parsePhoneNumber = parsePhoneNumber

import Datetime from 'vue-datetime'
// You need a specific loader for CSS files
import 'vue-datetime/dist/vue-datetime.css'

Vue.use(Datetime)

import Meta from 'vue-meta'
Vue.use(Meta)

Vue.mixin({
  methods: {
    showToastError: function (error) {
      Vue.toasted.show(error, {
        theme: 'bubble',
        position: 'top-right',
        duration: 3000
      })
    },
    getUser() {
      if (!window.location.href.indexOf("login") && store.getters.USER == null) {
        console.error("not login page and USER is null, redirect") // actually, because all pages are not alive anymore, go back to any page to cause 401 and redirect, so this is not useful
        window.location.href = '/#/login/'
      }
      return store.getters.USER
    },
    meterToMile(meter) {
      return meter * 0.000621371
    },
    handle401() {
      window.location.href = '/#/login/'
    },
    check403(error) {
      if (error.response.status == 403) {
        console.warn("forbidden, redirect to login")
        window.location.href = '/#/login/'
      }
    }
  }
})

Vue.filter('driverTags', function (value) {
  if (value.length) {
    var tags = [];
    value.forEach((el) => {
      tags.push(el.value);
    })
    return [...new Set(tags)].join(', ');
  }
  return 'N/A';
})
Vue.filter('rideTags', function (value, tag_code) {
  if (value.length) {
    var tags = [];

    // 
    var return_value = null;
    if (value && value.length > 0) {
      for (var i=0; i < value.length; i++) {
        if (value[i].code == tag_code && value[i].values) {
          for (var j=0; j < value[i].values.length; j++) {
            if (!return_value) {
              return_value = value[i].values[j].value
            } else {
              return_value = return_value + ", " + value[i].values[j].value
            }
          }
        }
      } 
    }
    return return_value ? return_value : 'N/A';
  }
  return 'N/A';
})

router.beforeEach((to, from, next) => {
  // console.log('beforeEach')

  if (to.matched.some(record => record.meta.guest)) {
    console.log('guest url')
    next()
    return
  }

  if (!store.getters.USER) {
    console.log('go to login')
    next({
      path: '/login/',
      params: { nextUrl: to.fullPath }
    })
    return
  }

  next()
})

import Axios from 'axios'
Vue.prototype.$http = Axios;
if (store.getters.USER) {
  Vue.prototype.$http.defaults.headers.common['Authorization'] = 'JWT ' + store.getters.USER.token
}

let vm = new Vue({
  el: '#app',
  store,
  router,
  components: { App },
  template: '<App/>',
  watch: {
    $route(to, from) {
      $(".left-sidebar #sidebarnav li").click(function () {
        $(".left-sidebar #sidebarnav li").each(function (index) {
          $(this).removeClass('active');
        });
      })
    }
  }
})

global.vm = vm



// WEBPACK FOOTER //
// ./src/main.js